<script>
  import BreadcrumbItem from "./BreadcrumbItem.svelte";
  import MyLink from "../../i18n/MyLink.svelte";

  export let items = []
</script>

<div class="breadcrumbs">
  {#each items as item, i}
    {#if i !== 0}
      <span>&gt;</span>
    {/if}
    <BreadcrumbItem active={item.active}>
      {#if item.active}
        {item.title}
      {:else}
        <MyLink href={item.href}>
          {item.title}
        </MyLink>
      {/if}
    </BreadcrumbItem>
  {/each}
</div>

<style>
  .breadcrumbs {
    padding: .5rem;
    display: inline-flex;
    flex-wrap: wrap;
    gap: .5rem;
  }
</style>
